<template>
  <div class="modal-out">
    <div class="modal">

      <div class="modal-header">
        <div class="title">检测人次</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>

      <div class="modal-body" style="padding: 10px;">

        <el-table class="table" ref="table" :data="tableData" style="width: 100%" border :height="400">
          <el-table-column label="老人名称" prop="name"></el-table-column>
          <el-table-column label="身份证号" prop="idcard"></el-table-column>
          <el-table-column label="地址" prop="address"></el-table-column>

          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <el-button size="small" @click="viewData(scope.row)">检测数据</el-button>
            </template>
          </el-table-column>

        </el-table>

        <div class="page">
          <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）
          </div>
          <div style="float: left;">
            <el-pagination
                background
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="20"
                :current-page.sync="currentPage"  @current-change="current_change">
            </el-pagination>
          </div>
          <div style="clear: both;"></div>
        </div>

      </div>

    </div>


    <Data2 ref="myData" v-show="showData" v-on:closeData="closeData"  v-on:getList="getData"></Data2>


  </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";

import Data2 from "../Comm/Data2";
import {hex_md5_with_china} from "@/common/Base64MD5";

//引入axios
//import axios from "axios";

export default {
  name: 'Data',
  data() {
    return {
      showData:false,

      loading: false,

      tableData:[],
      totalItems:0,
      pageSize: 20,
      currentPage: 1,

      deviceID:'',

      bodyStyle:"height:"+(this.$store.state.tableHeight+50)+'px',
      th:this.$store.state.tableHeight,
    }
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.bodyStyle = "height:"+(val+50)+'px';
      this.th=val
    },
  },
  created() {

    // //创建实例时设置配置的默认值
    // const httpHandler = axios.create({
    //   headers: { "Content-Type": "application/json;charset=utf-8" }, //即将被发送的自定义请求头
    //   withCredentials: true //表示跨域请求时是否需要使用凭证
    // });
    //
    // let uri = "/apis/query/person/queryDetectList";
    // httpHandler.get(uri).then(result => {
    //   console.log(result);
    // }) .catch(error => {
    //   console.error(error);
    // });

    //this.getData();

  },
  components: {Data2},
  methods: {

    init(deviceID){
      this.deviceID = deviceID;
      //this.getData()

      this.tableData = [];
      this.totalItems=0;
      this.getData2()
    },

    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

    closeSelf() {
      this.$emit("closeData");
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      //this.getData();
      this.getData2();
    },

    getTime(row,index,column){
      return timefilters(column)
    },

    getData(){
      this.loading = true;

      this.$axios({
        method: 'get',
        url: "/apis/query/person/queryDetectList?deviceId="+this.deviceID,
      }).then((response) => {
        //console.log(response);
        this.loading = false;
        if (response.data.errorCode == '') {
          //this.tableData=response.data.results;
          this.totalItems = response.data.results.length;

          let arr = response.data.results;
          let arr2 = [];

          let start = (this.currentPage-1)*this.pageSize;
          let end = start + this.pageSize;
          for(let i=0;i<arr.length;i++){
            if(i>=start && i<end){
              arr2.push(arr[i]);
            }
          }
          this.tableData = arr2;

          this.$nextTick(()=>{
            this.$refs.table.doLayout();
          });

        }
        else{
          this.$message.error(response.data.errorDesc);
        }

      })

    },

    getData2(){
      var _this=this
      this.tableLoading=true

      let data = {
        timeStr: timeStr,
        sign: "",
        deviceID: this.deviceID,
      };


      data.sign = "";
      data.sign = hex_md5_with_china("jsonStr=" + JSON.stringify(data) + "&key="+this.$signKey)


      this.$axios({
        method: "post",
        url: this.$deviceUrl + "GroupGarea/ListByDeviceID",
        data: data,
      }).then((response) => {
        _this.tableLoading=false
        if (response.data.error == 0) {

          let rv = response.data.data.rv;
          //console.log(rv);

          let obj = JSON.parse(rv);

          let arr = obj.results;
          let arr2 = [];

          let start = (this.currentPage-1)*this.pageSize;
          let end = start + this.pageSize;
          for(let i=0;i<arr.length;i++){
            if(i>=start && i<end){
              arr2.push(arr[i]);
            }
          }
          this.tableData = arr2;
          this.totalItems = obj.results.length;

          this.$nextTick(()=>{
            this.$refs.table.doLayout();
          });

        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        _this.tableLoading=false
        console.log(error);
      });
    },


    viewData(row){
      this.showData = !this.showData;
      this.$refs.myData.init(row.idcard);
    },
    closeData:function(){
      this.showData = !this.showData;
    },

  }
}


</script>


